export class PTWApprovals {
  ApprovalType: number;
  CertificateId?: number;
  PermitId: number;
  ApprovedBy: number;
  IsApproved: boolean;
  IsDailyPreValidation: boolean;
  IsHoursValidation: boolean;
  PermitApprovedFrom: Date = new Date();
  PermitApprovedTo: Date = new Date();
  ExtensionValidTo: Date = new Date();
  CreatedDate: Date = new Date();
  Remarks: string;
  IsEquipmentSafeCondition?:boolean;
  IsWorksiteSafeAndClear?:boolean;
  IsReinstatementsComplete?:boolean;
}
